module.exports = __webpack_public_path__ + "static/media/thumbs-up-fill.81d2baf3.svg";